import YogaFilter from './YogaFilter'

export default YogaFilter
// eslint-disable-next-line import/export
export * from './YogaFilter'
